export interface FinalDocumentAdmissionModel {
  lastReceiptDate: Date;
  appealDate: string[];
  appealDateExpiration: Date;
}

export const initalFinalDocumentAdmissionModel = {
  lastReceiptDate: '',
  appealDate: [],
  appealDateExpiration: null,
};

export enum APPEAL_DATE {
  FIFTHTEENDAYS = '15 dana',
  THIRTYDAYS = '30 dana',
}

export interface NonWorkingDaysModel {
  publicHoliday: boolean;
  weekendDay: boolean;
  numberOfDaysToNextWorkingDay: number;
}
